
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, LucideIcon } from "lucide-react";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  features: string[];
  buttonText: string;
  onSchedule: () => void;
}

export function ServiceCard({ 
  icon: Icon, 
  title, 
  description, 
  features, 
  buttonText, 
  onSchedule 
}: ServiceCardProps) {
  return (
    <Card className="hover:shadow-lg transition-shadow h-full flex flex-col">
      <CardContent className="p-8 text-center flex-1 flex flex-col">
        <Icon className="w-16 h-16 text-brand-primary mx-auto mb-6" />
        <h3 className="text-2xl font-semibold mb-4 font-accent">{title}</h3>
        <p className="font-text text-gray-600 mb-6 flex-1 text-lg">
          {description}
        </p>
        <div className="space-y-3 mb-6">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center">
              <CheckCircle className="w-5 h-5 text-brand-primary mr-2" />
              <span className="font-text text-gray-600">{feature}</span>
            </div>
          ))}
        </div>
        <Button 
          className="w-full bg-brand-primary hover:bg-brand-primary/90 font-accent mt-auto"
          onClick={onSchedule}
        >
          {buttonText}
        </Button>
      </CardContent>
    </Card>
  );
}
